import React, { Component } from "react";
import ENV from "../../common/env";
import { Modal, Checkbox, message, DatePicker, Select, TreeSelect } from "antd";
import API_URL from "../../common/url";
import $ from "../../common/AjaxRequest";
import ExportUtil from "../../common/ExportUtil";
import moment from 'moment';
import SelectAreaCity from "../common/SelectAreaCity";
import SelectProvince from "../common/SelectProvince";
import fp from "../../utils/fp";

const monthFormat = "YYYY-MM";

const { MonthPicker } = DatePicker;
const CheckboxGroup = Checkbox.Group;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;

const EXPORT = {
    heredity: {
        matched: "1",
        url: API_URL.investigation.seniorExportHeredityList,
    },
    researchCenterCost: {
        matched: "1",
        url: API_URL.investigation.exportInvestigationSiteFeeSuper,
    },
    planVisitSetting: {
        matched: "1",
        url: API_URL.investigation.exportInvestigationPlanVisitSettingSuper,
    },
};
const DOWNLOADSITE = {
    centerStartUp: {
        matched: "1",
        type: "CENTER_START_RECORD",
        url: API_URL.investigation.exportInvestigationSiteStart,
    },
    centerShutOff: {
        matched: "1",
        type: "CENTER_END_RECORD",
        url: API_URL.investigation.exportInvestigationSiteClose,
    },
    projectDataWriteRate: {
        matched: "1",
        type: "PROJECT_WRITE_RATE",
        url: API_URL.investigation.exportSeniorInvestigation2,
    },
    competingCompany: {
        matched: "1",
        type: "COMPETING_COMPANY",
        url: API_URL.investigation.exportSeniorInvestigation2,
    },
    isChecked: {
        matched: true,
        type: "INVESTIGATION_SENIOR",
        url: API_URL.investigation.exportSeniorInvestigation2,
    },
    workPercent: {
        matched: "1",
        type: "ALL_FINISH_DETAIL",
        url: API_URL.sumtotal.exportSeniorAllInvestigation,
    },
};

//换行样式
const whiteSpaceStyle = {
    display: 'inline-block',
    whiteSpace: 'initial',
    verticalAlign: 'top',
    width: '160px',
}

class AdvancedExport extends Component {
    state = {
        visible: false,
        basicOptions: [
            { label: "项目简称", value: "_investigationName", checked: "0" },
            {
                label: "项目名称",
                value: "_investigationSpecialName",
                checked: "0",
            },
            {
                label: "项目识别码",
                value: "investigationIdentifyCode",
                checked: "0",
            },
            { label: "临床评估单号", value: "evaluateCode", checked: "0" },
            { label: "项目编号", value: "_investigationCode", checked: "0" },
            { label: "CDE登记号", value: "_cdeNum", checked: "0" },
            {
                label: "JDE主项目号",
                value: "_investigationJdeContractCode",
                checked: "0",
            },
            {
                label: "项目类型",
                value: "_investigationGlobalType",
                checked: "0",
            },  
            { label: "项目级别", value: "levelName", checked: "0" },
            { label: "项目是否需要过遗传办", value: "investigationNeedHeredity", checked: "0" },
            { label: "项目状态", value: "invStatus", checked: "0" },
            { label: "项目阶段", value: "_stageName", checked: "0" },
            { label: "项目暂停情况", value: "investigationPauseInfo", checked: "0" },
            { label: "项目暂停原因", value: "investigationPauseReason", checked: "0" },
            { label: "项目预计恢复日期", value: "investigationEstimatedRecoveryDate", checked: "0" },
            { label: "项目暂停日期", value: "investigationPauseDate", checked: "0" },
            { label: "暂停周期", value: "investigationPauseCycle", checked: "0" },
            { label: "项目实际恢复日期", value: "investigationActualRecoveryDate", checked: "0" },
            { label: "项目终止情况", value: "investigationTerminationInfo", checked: "0" },
            { label: "计划锁库日期", value: "investigationPlanLockDate", checked: "0" },
            { label: "实际锁库日期", value: "investigationActualLockDate", checked: "0" },
            { label: "项目进展", value: "investigationProceedInfo", checked: "0" },
            { label: "项目是否结束入组", value: "isFinishInGroup", checked: "0" },
            { label: "项目实际结束入组时间", value: "actualFinishInGroupTimeShow", checked: "0" },
            { label: "暂停/终止时间", value: "terminationTime", checked: "0" },
            { label: "中心启动情况", value: "_siteStartState", checked: "0" },
            { label: "项目分类", value: "typeName", checked: "0" },
            { label: "项目领域", value: "investigationAreaName", checked: "0" },
            { label: "疾病分类", value: "diseaseClassName", checked: "0" },
            { label: "疾病", value: "diseaseName", checked: "0" },
            {
                label: "研究产品类型",
                value: "investigationMedicineName",
                checked: "0",
            },
            { label: "肿瘤治疗方式", value: "treatmentMethod", checked: "0" },
            {
                label: (
                    <span>
                        药物(疗法)分类
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/主要作用靶点
                    </span>
                ),
                value: "_drugMainTargets",
                checked: "0",
            },
            {
                label: (
                    <span>
                        研究药物通用名称
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/产品具体名称/技术名称
                    </span>
                ),
                value: "investigationMedicine",
                checked: "0",
            },
            {
                label: "给药方式",
                value: "administrationMode",
                checked: "0",
            },
            {
                label: "项目分期",
                value: "investigationByStageName",
                checked: "0",
            },
            { label: "受试者类型", value: "testeeTypeName", checked: "0" },
            { label: "合同签署方", value: "_contractSignCompanyName", checked: "0" },
            { label: "申办方", value: "investigationSponsor", checked: "0" },
            { label: "CRO", value: "_CRO", checked: "0" },
            { label: "其他合作公司", value: "otherPartnerCompany", checked: "0" },
            { label: "业务线", value: "_lineOfBusiness", checked: "0" },
            {
                label: "执行业务线二级分类",
                value: "_secondLineName",
                checked: "0",
            },
            {
                label: "项目性质",
                value: "_invNature",
                checked: "0",
            },
            {
                label: "配套盲态项目",
                value: "_blindInvestigationName",
                checked: "0",
            },
            {
                label: "配套启动前项目",
                value: "_beforeInvestigationName",
                checked: "0",
            },
            {
                label: "项目计划开始时间",
                value: "investigationPlanBeginTime",
                checked: "0",
            },
            {
                label: "项目计划结束时间",
                value: "investigationPlanEndTime",
                checked: "0",
            },
            {
                label: "计收入确认方式",
                value: "contractTypeName",
                checked: "0",
            },
            {
                label: "合同额含税/人民币(元)",
                value: "investigationContractAmount",
                checked: "0",
            },
            { label: "合同FTE", value: "planAmount", checked: "0" },
            {
                label: "合同计划中心数量",
                value: "contractSitePlanAmount",
                checked: "0",
            },
            {
                label: "合同计划知情数量",
                value: "contractInformedPlanAmount",
                checked: "0",
            },
            {
                label: "合同计划筛选数量",
                value: "contractFilterPlanAmount",
                checked: "0",
            },
            {
                label: "合同计划随机(入组)数量",
                value: "contractRandomPlanAmount",
                checked: "0",
            },
            {
                label: "合同计划标准访视数",
                value: "contractStandardAmount",
                checked: "0",
            },
            {
                label: "津石计划负责中心数量",
                value: "planSiteCount",
                checked: "0",
            },
            {
                label: "津石计划知情数量",
                value: "typeInformedPlan",
                checked: "0",
            },
            {
                label: "津石计划筛选数量",
                value: "typeFilterPlan",
                checked: "0",
            },
            {
                label: "津石计划随机(入组)数量",
                value: "typeRandomPlan",
                checked: "0",
            },
            {
                label: "访视周期计划是否已发布",
                value: "isPlanSetting",
                checked: "0",
            },
            { label: "津石计划访视数量", value: "typeVisitPlan", checked: "0" },
            {
                label: "津石计划标准访视数",
                value: "standardVisitAmount",
                checked: "0",
            },
            {
                label: (
                    <span style={whiteSpaceStyle}>
                        津石第一家研究中心启动计划开始时间
                    </span>
                ), 
                value: "firstSiteStartTime",
                checked: "0",
            },
            {
                label: (
                    <span style={whiteSpaceStyle}>
                        津石100%中心启动计划开始时间
                    </span>
                ),
                value: "oneHundredPercentSiteStartTime",
                checked: "0",
            },
            {
                label: (
                    <span style={whiteSpaceStyle}>
                        津石首例受试者随机（入组）计划开始时间
                    </span>
                ),
                value: "firstPatientGroupStartTime",
                checked: "0",
            },
            {
                label: (
                    <span style={whiteSpaceStyle}>
                        津石100%受试者随机（入组）计划开始时间
                    </span>
                ), 
                value: "oneHundredPercentGroupStartTime",
                checked: "0",
            },
            {
                label: "是否为对垒项目",
                value: "_isAgainstInvestigation",
                checked: "0",
            },
            {
                label: "研究亮点",
                value: "_highlights",
                checked: "0",
            },
            { label: "研究周期", value: "_researchCycle", checked: "0" },
            { label: "项目经理", value: "_pm", checked: "0" },
            { label: "PML", value: "_pml", checked: "0" },
            { label: "PML上级", value: "pmlLeaderName", checked: "0" },
            { label: "项目管理员", value: "pa", checked: "0" },
            { label: "BD", value: "_bd", checked: "0" },
            { label: "CSA", value: "_csa", checked: "0" },
            { label: '领域leader', value: '_leader', checked: '0' },
            { label: '大客户经理', value: 'keyAccountManager', checked: '0' },
            { label: '协助项目成员', value: '_pma', checked: '0' },
        ],
        processOptions: [
            { label: "预估FTE数", value: "estimateFte", checked: "0" },
            {
                label: "累计消耗FTE数",
                value: "cumulativeConsumptionFte",
                checked: "0",
            },
            {
                label: "项目当月累计完工百分比",
                value: "cumulativeFinishPersent",
                checked: "0",
            },
            {
                label: "累计开票进度百分比",
                value: "_accumulateInvoiceProgressPercent",
                checked: "0",
            },
            {
                label: "累计回款进度百分比",
                value: "_accumulateBackProgressPercent",
                checked: "0",
            },
            {
                label:(
                    <span>
                        累计开票进度和
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;完工进度金额差异（不含税）
                    </span>
                ),
                value: "_accumulateInvoiceFinishDeviation",
                checked: "0",
            },
            {
                label: (
                    <span>
                        累计回款进度和
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;完工进度金额差异（不含税）
                    </span>
                ),
                value: "_accumulateBackFinishDeviation",
                checked: "0",
            },
            {
                label: (
                    <span>
                        项目当月合同&初始计划
                        <br />
                        &nbsp;
                    </span>
                ),
                value: "contractInitialPlan",
                checked: "0",
            },
            {
                label: "项目当月累计进度动态参考值",
                value: "accumulativeProgress",
                checked: "0",
            },
            {
                label: "实际启动中心数",
                value: "cumulativeSiteCount",
                checked: "0",
            },
            { label: "累计知情数", value: "informedCount", checked: "0" },
            { label: "累计筛选数", value: "filterCount", checked: "0" },
            { label: "累计随机(入组)数", value: "randomCount", checked: "0" },
            { label: "累计完成访视数", value: "visitCount", checked: "0" },
            {
                label: "累计完成访视数（计划内）",
                value: "_visitPlanCount",
                checked: "0",
            },
            {
                label: "累计完成访视数（计划外）",
                value: "_visitOutPlanCount",
                checked: "0",
            },
            {
                label: "累计完成标准访视数",
                value: "standardVisit",
                checked: "0",
            },
            {
                label: "累计完成标准访视数（计划内）",
                value: "_standardInVisit",
                checked: "0",
            },
            {
                label: "累计完成标准访视数（计划外）",
                value: "_standardOutVisit",
                checked: "0",
            },
            {
                label: "当月确认标准访视数",
                value: "monthStandardVisit",
                checked: "0",
            },
            { label: "累计退出数", value: "dropCount", checked: "0" },
            { label: "累计方案违背数", value: "violationCount", checked: "0" },
            { label: "累计重大事件数", value: "majorEventCount", checked: "0" },
            { label: "累计SAE数", value: "saeCount", checked: "0" },
            // { label: '津石累计启动中心数量', value: 'cumulativeSiteCount', checked: "0" },
            {
                label: "津石当前管理的在组病例数",
                value: "cumulativePatientInProgress",
                checked: "0",
            },
            {
                label: "津石累计完成研究病例数",
                value: "cumulativePatientCompleted",
                checked: "0",
            },
            {
                label: "津石当月新入组病例数",
                value: "cumulativeRandom",
                checked: "0",
            },
            { label: "月启动速率", value: "monthBeginSpeed", checked: "0" },
            { label: "平均启动时长", value: "avgBeginDay", checked: "0" },
            { label: "入组周速率", value: "weekGroupSpeed", checked: "0" },
            { label: "入组月速率", value: "monthGroupSpeed", checked: "0" },
            { label: "累计回款金额/人民币", value: "_receivingAmount", checked: "0" },
        ],
        siteBasicOptions: [
            { label: "中心编号", value: "investigationSiteCode", checked: "0" },
            { label: "中心名称", value: "investigationSiteName", checked: "0" },
            { label: "院区", value: "CourtyardArea", checked: "0" },
            { label: "科室", value: "departmentName", checked: "0" },
            { label: "研究中心项目阶段", value: "siteStageNames", checked: "0" },
            { label: (
                <span style={whiteSpaceStyle}>
                    中心合同计划单访视工时折算系数
                </span>
            ), value: "visitHourConversionFactor", checked: "0" },
            { label: "区域", value: "_siteArea", checked: "0" },
            { label: "城市", value: "_siteCity", checked: "0" },
            { label: (
                <span style={whiteSpaceStyle}>
                    县级行政区（如无则默认为上级行政单位）
                </span>
            ),
                value: "_siteCounty", 
                checked: "0"
            },
            {
                label: "JDE项目号",
                value: "siteInvestigationJdeContractCode",
                checked: "0",
            },
            { label: "启动时间", value: "siteStartUpTime", checked: "0" },
            { label: "启动时长(天)", value: "siteBeginDay", checked: "0" },
            { label: "中心周速率", value: "siteWeekSpeed", checked: "0" },
            { label: "中心月速率", value: "siteMonthSpeed", checked: "0" },
            { label: "FPI", value: "FPI", checked: "0" },
            { label: "LPI", value: "LPI", checked: "0" },
            { label: "LPO", value: "LPO", checked: "0" },
            { label: "预筛数量", value: "preFilterCount", checked: "0" },
            {
                label: "计划知情数",
                value: "siteTypeInformedPlan",
                checked: "0",
            },
            {
                label: "实际知情数",
                value: "siteTypeInformedActual",
                checked: "0",
            },
            { label: "计划筛选数", value: "siteTypeFilterPlan", checked: "0" },
            {
                label: "实际筛选数",
                value: "siteTypeFilterActual",
                checked: "0",
            },
            {
                label: "计划随机(入组)数",
                value: "siteTypeRandomPlan",
                checked: "0",
            },
            {
                label: "实际随机(入组)数",
                value: "siteTypeRandomActual",
                checked: "0",
            },
            { label: "筛选失败数量", value: "filterFailCount", checked: "0" },
            {
                label: "在组患者数量",
                value: "patientsInGroupCount",
                checked: "0",
            },
            {
                label: "患者退出数量",
                value: "siteBasicDropCount",
                checked: "0",
            },
            {
                label: "方案违背数量",
                value: "siteBasicViolationCount",
                checked: "0",
            },
            { label: "SAE数量", value: "siteBasicSaeCount", checked: "0" },
            {
                label: "该中心交接次数",
                value: "siteHandoverCount",
                checked: "0",
            },
            { label: "关中心时间", value: "siteEndTime", checked: "0" },
            { label: "CRC", value: "CRC", checked: "0" },
            { label: "是否在site授权表上正式授权", value: "isSiteFormalAuthorization", checked: "0" },
            { label: "授权时间", value: "authorizationDate", checked: "0" },
            { label: "CRC工作类型", value: "crcRequirementInfoType", checked: "0" },
            { label: "PI", value: "PI", checked: "0" },
            { label: "CRA", value: "CRA", checked: "0" },
        ],
        siteProcessOptions: [
            { label: "累计知情数", value: "siteInformedCount", checked: "0" },
            { label: "累计筛选数", value: "siteFilterCount", checked: "0" },
            {
                label: "累计随机(入组)数",
                value: "siteRandomCount",
                checked: "0",
            },
            { label: "累计完成访视数", value: "siteVisitCount", checked: "0" },
            { label: "累计退出数", value: "siteDropCount", checked: "0" },
            {
                label: "累计方案违背数",
                value: "siteViolationCount",
                checked: "0",
            },
            { label: "累计SAE数", value: "siteSaeCount", checked: "0" },
            { label: "是否被核查", value: "_isVerifyResultShow", checked: "0" },
            { label: "核查结果", value: "_verifyResult", checked: "0" },
        ],
        heredityOptions: [{ label: "", value: "heredity", checked: "0" }],
        centerStartUpOptions: [
            { label: "", value: "centerStartUp", checked: "0" },
        ],
        centerShutOffOptions: [
            { label: "", value: "centerShutOff", checked: "0" },
        ],
        //项目数据填写统计
        projectDataFillOptions: [
            { label: "", value: "projectDataWriteRate", checked: "0" },
        ],
        costOptions: [{ label: "", value: "researchCenterCost", checked: "0" }],
        percentOptions: [{ label: "", value: "workPercent", checked: "0" }],
        companyOptions: [
            { label: "", value: "competingCompany", checked: "0" },
        ],
        planVisitSettingOptions: [
            { label: "", value: "planVisitSetting", checked: "0" },
        ],
        lineOfBusinessChangeRecord:[
        { label: "", value: "lineOfBusinessChange", checked: "0" },
        ],
        searchParams: {},
    };

    handleSubmit = () => {
        const { searchArray } = this.props;
        let { status } = searchArray;
        if (status == null || status == "" || status == undefined)
            searchArray.status = "DISCUSSING";
        const statusSymbol =
            searchArray.status == "DISCUSSING" ? "NotEquals" : "Equals";

        searchArray.statusSymbol = statusSymbol;
        const {
            basicOptions,
            processOptions,
            siteBasicOptions,
            siteProcessOptions,
            heredityOptions,
            centerStartUpOptions,
            centerShutOffOptions,
            projectDataFillOptions,
            costOptions,
            percentOptions,
            companyOptions,
            planVisitSettingOptions,
            lineOfBusinessChangeRecord,
            searchParams
        } = this.state;
        const options = [
            ...basicOptions,
            ...processOptions,
            ...siteBasicOptions,
            ...siteProcessOptions,
            ...heredityOptions,
            ...centerStartUpOptions,
            ...centerShutOffOptions,
            ...projectDataFillOptions,
            ...costOptions,
            ...percentOptions,
            ...companyOptions,
            ...planVisitSettingOptions,
            ...lineOfBusinessChangeRecord
        ];
        const { searchParams: { startMonth, endMonth, areaParams } } = this.state;
        let isChecked = false;
        options.forEach((option) => {
            const { checked, value } = option;
            if (
                checked == 1 &&
                value != "heredity" &&
                value != "centerStartUp" &&
                value != "centerShutOff" &&
                value != "projectDataWriteRate" &&
                value != "workPercent" &&
                value != "researchCenterCost" &&
                value != "competingCompany"&&
                value != "planVisitSetting"&&
                value != "lineOfBusinessChange"
            ) {
                isChecked = true;
            }
            searchArray[value] = checked;
            // if (typeof checked === 'number' && checked > 0) {
            //     searchArray[value] = checked;
            // }
        });
        // 当竞争公司和项目信息一同导出时 忽略项目导出
        if (
            isChecked &&
            searchArray.competingCompany == 1 &&
            (siteBasicOptions.every((i) => i.checked != 1) &&
                siteProcessOptions.every((i) => i.checked != 1))
        ) {
            isChecked = false;
        }
        delete searchArray.contractTypeList;
        delete searchArray.levelList;
        delete searchArray.stageList;
        delete searchArray.typeList;
        delete searchArray.areaList;
        delete searchArray.diseaseList;
        delete searchArray.investigationByStageList;
        for (let [key, value] of Object.entries(DOWNLOADSITE)) {
            if (
                searchArray[key] === value.matched ||
                isChecked === value.matched
            ) {
                const params = { ...searchArray };
                if (value.matched === true && params.competingCompany == 1) {
                    params.competingCompany = '0';
                }
                if (key === 'competingCompany' && searchArray[key] == 1) {
                    siteBasicOptions.forEach(i => params[i.value] = '0');
                    siteProcessOptions.forEach(i => params[i.value] = '0');
                    params.projectDataWriteRate = 0;
                }
                if (key === 'projectDataWriteRate' && searchArray[key] == 1) {
                    params.competingCompany = 0;
                }
                if (key === 'workPercent' && searchArray[key] == 1) {
                    params.type = 'DETAIL';
                    this.addToDownloadSite({...params}, value.url, value.type);
                    return
                }
                this.addToDownloadSite({...params, ...searchParams, ...areaParams}, value.url, value.type);
            }
        }
        for (let [key, value] of Object.entries(EXPORT)) {
            if (searchArray[key] === value.matched) {
                this.downloadFile(value.url, searchArray);
            }
        }
        if(searchArray["lineOfBusinessChange"] == 1){
            const exportParams ={...searchArray,...searchParams}
            if( startMonth || endMonth ) {
                if( startMonth && endMonth ) {
                    this.downloadFile(API_URL.contract.exportLineOfBusinessChangeLog, exportParams);
                } else {
                    message.warning('请选择开始月份和结束月份');
                    return
                }
            } else {
                this.downloadFile(API_URL.contract.exportLineOfBusinessChangeLog, exportParams);
            }
        }
        this.hide();
    };

    downloadFile = (url, data) => {
        const options = {
            method: "POST",
            url,
            data,
            dataType: "json",
            // xhrFields: {
            //     responseType: "arraybuffer",
            // },
            doneResult: (response, status, xhr) => {
                message.success(response.success);
                return;

                
                // var filename = "";
                // var disposition = xhr.getResponseHeader("Content-Disposition");
                // if (disposition && disposition.indexOf("attachment") !== -1) {
                //     var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                //     var matches = filenameRegex.exec(disposition);
                //     if (matches != null && matches[1]) {
                //         filename = matches[1].replace(/['"]/g, "");
                //     }
                // }

                // var type = xhr.getResponseHeader("Content-Type");
                // var blob = new Blob([response], { type });

                // var URL = window.URL || window.webkitURL;
                // var downloadUrl = URL.createObjectURL(blob);

                // if (typeof window.navigator.msSaveBlob !== "undefined") {
                //     // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                //     window.navigator.msSaveBlob(blob, filename);
                // } else {
                //     if (filename) {
                //         // use HTML5 a[download] attribute to specify filename
                //         var a = document.createElement("a");
                //         // safari doesn't support this yet
                //         if (typeof a.download === "undefined") {
                //             window.location.href = downloadUrl;
                //         } else {
                //             a.href = downloadUrl;
                //             a.download = decodeURIComponent(filename);
                //             a.target = "_self";
                //             document.body.appendChild(a);
                //             a.click();
                //         }
                //     } else {
                //         window.location.href = downloadUrl;
                //     }

                //     setTimeout(
                //         () => URL.revokeObjectURL(downloadUrl),
                //         10 * 60 * 1000
                //     ); // cleanup
                // }
            },
        };
        $.sendRequest(options);
    };

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: "POST",
            url:
                type == "PROJECT_WRITE_RATE"
                    ? API_URL.investigation.startAsynchronousExport
                    : API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: "json",
            doneResult: (res) => {
                const { asynchronousExportId } = res;
                const params = { ...searchArray, asynchronousExportId };
                this.downloadFile(url, params);
            },
        };
        $.sendRequest(options);
    };

    show = stageIds => {
        const { searchParams } = this.state;
        searchParams.seniorStageIds = stageIds;
        this.setState({ visible: true, searchParams });
    };

    hide = () => {
        this.setState({ visible: false,
            searchParams:{}
        },() => {
            var timerId = setTimeout( () => {
                this.props.advancedExportShow()
                clearTimeout(timerId);
            }, 1000);
        });
    };

    onChange = (checkedValues = [], optionType) => {
        const typeObj = this.state[optionType];
        typeObj.map((option, index) => {
            if (checkedValues.includes(option.value)) {
                typeObj[index].checked = "1";
            } else {
                typeObj[index].checked = "0";
            }
        });
        this.setState({
            [optionType]: typeObj,
        });
    };

    onCheckChange = (e, optionType) => {
        const typeObj = this.state[optionType];
        typeObj.map((option, index) => {
            typeObj[index].checked = e.target.checked ? "1" : "0";
        });
        this.setState({
            [optionType]: typeObj,
        });
        if(optionType=="lineOfBusinessChangeRecord"){
            this.changeSearchParams({ 
                startMonth: "",
                endMonth: ""
             });
        }
    };

    changeSearchParams = (params) => {
        const { searchParams } = this.state;
        this.setState({ searchParams: { ...searchParams, ...params } });
    }

    handleDateChange = (data, dateString, key) => {
        const { searchParams: { startMonth, endMonth } } = this.state;
        if (key === 'startMonth') {
            if (endMonth) {
                if (moment(dateString).valueOf() > moment(endMonth).valueOf()) {
                    this.changeSearchParams({
                        startMonth: endMonth,
                        endMonth: dateString,
                    });
                    return;
                } 
                // else if (moment(dateString).valueOf() === moment(endMonth).valueOf()) {
                //     message.warning('不能选择单月！');
                //     return;
                // }
            }
            this.changeSearchParams({ [key]: dateString });
        } else if (key === 'endMonth') {
            if (startMonth) {
                if (moment(dateString).valueOf() < moment(startMonth).valueOf()) {
                    this.changeSearchParams({
                        startMonth: dateString,
                        endMonth: startMonth,
                    });
                    return;
                } 
                // else if (moment(dateString).valueOf() === moment(startMonth).valueOf()) {
                //     message.warning('不能选择单月！');
                //     return;
                // }
            }
            this.changeSearchParams({ [key]: dateString });
        } else {
            this.changeSearchParams({ [key]: dateString });
        }  
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleChange = ( value, key ) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if( key == 'seniorStageIds') {
            searchParams[key] = value.join(',');
        }
        this.setState({ searchParams })
    }

    render() {
        const {
            visible,
            confirmLoading,
            basicOptions,
            processOptions,
            siteBasicOptions,
            siteProcessOptions,
        } = this.state;
        const basicOptionsChecked = [];
        basicOptions.map((option) => {
            if (option.checked == "1") {
                basicOptionsChecked.push(option.value);
            }
        });
        const processOptionsChecked = [];
        processOptions.map((option) => {
            if (option.checked == "1") {
                processOptionsChecked.push(option.value);
            }
        });
        const siteBasicOptionsChecked = [];
        siteBasicOptions.map((option) => {
            if (option.checked == "1") {
                siteBasicOptionsChecked.push(option.value);
            }
        });
        const siteProcessOptionsChecked = [];
        siteProcessOptions.map((option) => {
            if (option.checked == "1") {
                siteProcessOptionsChecked.push(option.value);
            }
        });
        const { 
            searchParams: { 
                startMonth, 
                endMonth, 
                seniorStageIds, 
                isSelfAreaSite, 
                areaName,
                hasCheckedArea = [], 
            },
            lineOfBusinessChangeRecord
        } = this.state;
        const { stageList } = this.props;
        const treeData = [{
            label: '进行中',
            value: '',
            key: '0-0',
            children: [],
        }, {
            label: '已结束',
            value: '',
            key: '0-1',
            children: [],
        }];
        stageList.forEach(( el, index ) => {
            if(fp.contains(el.typeValue)(['项目执行工作全部完成', '项目暂停', '项目终止', '项目关闭','服务合同签署前终止','业务数据归档'])){
                treeData[1].children.push({
                    label: el.typeValue,
                    value: `${el.typeConfigureId}`,
                    key: `0-0-${treeData[1].children.length}`,
                })
                treeData[1].value = treeData[1].value == '' ? el.typeConfigureId : `${treeData[1].value},${el.typeConfigureId}`
            }else {
                treeData[0].children.push({
                    label: el.typeValue,
                    value: `${el.typeConfigureId}`,
                    key: `0-1-${treeData[0].children.length}`,
                })
                treeData[0].value = treeData[0].value == '' ? el.typeConfigureId : `${treeData[0].value},${el.typeConfigureId}`
            }
        })
        return (
            <Modal
                title="请选择导出项"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="condition-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="850px"
                confirmLoading={confirmLoading}
            >
                <div className="con-options config_column">
                    <div className="export-filter">
                        <div className="filter-item">
                            <label >项目阶段</label>
                            <TreeSelect
                                allowClear={true}
                                treeData={treeData}
                                value={seniorStageIds ? seniorStageIds.split(',') : []}
                                onChange={value => this.handleChange(value, 'seniorStageIds')}
                                treeCheckable={true}
                                showCheckedStrategy={SHOW_PARENT}
                                searchPlaceholder='请选择'
                                style={{ width: 220 }}
                            />
                        </div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "basicOptions")
                            }
                        >
                            项目基本信息
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div style={{ marginLeft: "25px" }}>
                        <CheckboxGroup
                            value={basicOptionsChecked}
                            options={basicOptions}
                            onChange={(e) => {
                                this.onChange(e, "basicOptions");
                            }}
                        />
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "processOptions")
                            }
                        >
                            项目进展情况
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div style={{ marginLeft: "25px" }}>
                        <CheckboxGroup
                            value={processOptionsChecked}
                            options={processOptions}
                            onChange={(e) => {
                                this.onChange(e, "processOptions");
                            }}
                        />
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "projectDataFillOptions")
                            }
                        >
                            项目数据填写统计
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "companyOptions")
                            }
                        >
                            竞争公司表现
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "lineOfBusinessChangeRecord")
                            }
                        >
                            业务线变更日志
                        </Checkbox>
                        <div className="clear"></div>
                            {lineOfBusinessChangeRecord&&lineOfBusinessChangeRecord[0].checked=="1"&&
                        <div className="search-item">
                        <label className="ui-label" style={{marginRight:"10px",marginLeft:"22px"}}>业务线变更日期</label>

                        <MonthPicker
                        className="begin"
                        format={monthFormat}
                        value={startMonth ? moment(startMonth) : null}
                        allowClear={true}
                        placeholder="开始月份"
                        disabledDate={this.disabledDate}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'startMonth')}
                    />
                    <label className="ui-label" style={{marginRight:"10px",marginLeft:"10px"}}>至</label>
                        <MonthPicker
                            className="end"
                            format={monthFormat}
                            value={endMonth ? moment(endMonth) : null}
                            allowClear={true}
                            placeholder="结束月份"
                            disabledDate={this.disabledDate}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'endMonth')}
                        />
                        </div>
                        }
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "planVisitSettingOptions")
                            }
                        >
                            计划访视参数设置
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div className="export-filter">
                        <div className="filter-item">
                            <label>是否自己区域内的中心</label>
                            <Select
                                placeholder="请选择"
                                value={isSelfAreaSite}
                                style={{ width: 80 }}
                                onChange={value => this.handleChange(value, 'isSelfAreaSite')}
                            >
                                <Option value="1">是</Option>
                                <Option value="0">否</Option>
                            </Select>
                        </div>
                        <div className="filter-item">
                            <label>区域/城市</label>
                            <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                        </div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "siteBasicOptions")
                            }
                        >
                            中心基本信息
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div style={{ marginLeft: "25px" }}>


                        
                        <CheckboxGroup
                            value={siteBasicOptionsChecked}
                            options={siteBasicOptions}
                            onChange={(e) => {
                                this.onChange(e, "siteBasicOptions");
                            }}
                        />
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "siteProcessOptions")
                            }
                        >
                            中心进展情况
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div style={{ marginLeft: "25px" }}>
                        <CheckboxGroup
                            value={siteProcessOptionsChecked}
                            options={siteProcessOptions}
                            onChange={(e) => {
                                this.onChange(e, "siteProcessOptions");
                            }}
                        />
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "heredityOptions")
                            }
                        >
                            遗传办
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "centerStartUpOptions")
                            }
                        >
                            中心启动记录
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "centerShutOffOptions")
                            }
                        >
                            中心关闭记录
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "costOptions")
                            }
                        >
                            研究中心费用
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                    <div>
                        <Checkbox
                            onChange={(e) =>
                                this.onCheckChange(e, "percentOptions")
                            }
                        >
                            完工百分比明细
                        </Checkbox>
                        <div className="clear"></div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default AdvancedExport;



// WEBPACK FOOTER //
// ./src/components/investigation/AdvancedExport.js